<section
  class="flex h-full w-full flex-col overflow-hidden bg-white text-gray-900"
  role="dialog"
  [attr.aria-label]="'board_v3_move_card_title' | translate"
>
  <header class="flex shrink-0 items-center gap-3 border-b border-gray-100 px-4 py-3">
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-blue-50 text-blue-600">
      <app-icon>drive_file_move</app-icon>
    </div>
    <div class="min-w-0 flex-1">
      <h2 class="m-0 text-base font-bold leading-6 text-gray-900">{{ 'board_v3_move_card_title' | translate }}</h2>
      @if (isBulk) {
        <p class="m-0 truncate text-sm leading-5 text-gray-500">
          {{ 'board_v3_selected_cards_count' | translate: { count: selectedCount } }}
        </p>
      } @else if (card?.name) {
        <p class="m-0 truncate text-sm leading-5 text-gray-500">{{ card?.name }}</p>
      }
    </div>
    <button
      type="button"
      class="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100"
      [attr.aria-label]="'close' | translate"
      (click)="onCancel()"
    >
      <app-icon>close</app-icon>
    </button>
  </header>

  <div class="shrink-0 border-b border-gray-100 px-4 py-3">
    <div class="relative">
      <app-icon class="pointer-events-none absolute left-3 top-1/2 !h-5 !w-5 -translate-y-1/2 !text-[20px] !leading-5 text-gray-400">
        search
      </app-icon>
      <input
        type="search"
        class="block h-11 w-full rounded-lg border border-gray-200 bg-white py-2 pl-10 pr-3 text-sm text-gray-900 outline-none placeholder:text-gray-400 focus:border-blue-400"
        [(ngModel)]="search"
        [placeholder]="'search' | translate"
      />
    </div>
  </div>

  <div class="crm-scroll min-h-0 flex-1 overflow-y-auto px-4 py-3">
    @if (targetColumns.length) {
      <div class="flex flex-col gap-2">
        @for (column of targetColumns; track column.id) {
          <button
            type="button"
            class="flex w-full min-w-0 items-center gap-3 rounded-lg border border-gray-100 bg-white px-3 py-3 text-left shadow-sm enabled:hover:bg-gray-50 disabled:cursor-default disabled:bg-gray-50 disabled:shadow-none"
            [disabled]="isCurrentColumn(column)"
            (click)="onSelectColumn(column)"
          >
            <span
              class="h-4 w-4 shrink-0 rounded-full border border-black/10"
              [style.backgroundColor]="column.color.background"
            ></span>
            <span class="min-w-0 flex-1 truncate text-sm font-medium text-gray-800">{{ column.name }}</span>
            @if (isCurrentColumn(column)) {
              <span class="rounded-full bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600">
                {{ 'board_v3_current_column' | translate }}
              </span>
            }
            <span class="rounded-full bg-gray-100 px-2 py-0.5 text-xs text-gray-500">{{ column.count_cards }}</span>
            @if (!isCurrentColumn(column)) {
              <app-icon class="shrink-0 !text-[18px] text-gray-400">chevron_right</app-icon>
            }
          </button>
        }
      </div>
    } @else {
      <div class="flex h-full min-h-48 flex-col items-center justify-center rounded-xl bg-gray-50 px-4 py-8 text-center">
        <app-icon class="mb-2 !text-[28px] text-gray-300">{{ hasSearch ? 'search_off' : 'view_column' }}</app-icon>
        <p class="m-0 text-sm font-medium text-gray-600">
          {{ (hasSearch ? 'nothing_found' : 'board_v3_move_card_empty') | translate }}
        </p>
      </div>
    }
  </div>
</section>
